/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {HeadertestComponent as ɵa} from './src/app/testm/headertest/headertest.component';